import axios from "axios";
import { apiConfiguration } from "plumbing/api";

export const joinChallenge = (slug: string) => {
  const url = `${apiConfiguration.apiUrl}/challenges/${slug}/join`;
  return axios.post<JoinChallengeResponse>(url);
};
